export const GET_USERS_LIST = "@iweb/GET_USERS_LIST"
export const ARE_USERS_LOADED = "@iweb/ARE_USERS_LOADED"
export const ADD_USER = "@iweb/ADD_USER"
export const EDIT_USER = "@iweb/EDIT_USER"
export const EDIT_ADMIN_PERMISSIONS_IN_ALL_USERS =
  "@iweb/EDIT_ADMIN_PERMISSIONS_IN_ALL_USERS"
